// extracted by mini-css-extract-plugin
export default {"bannerComponent":"Gl-z","red":"Hl-z","calloutlink":"Il-z","headerTopBanner":"Jl-z","bgcolorRed":"Kl-z","headerTopCallout":"Ll-z","searchBanner":"Ml-z","hideMobile":"Nl-z"};